import React from "react";
import {
  LuGlobe,
  LuExternalLink,
} from "react-icons/lu";

export default function SearchResultItem({
  result,
  selected,
  onSelect,
}) {
  return (
    <button
      type="button"
      onClick={() => onSelect(result)}
      className={`group block w-full border-b border-slate-100 px-4 py-3 text-left transition last:border-b-0 ${
        selected
          ? "bg-blue-50"
          : "bg-white hover:bg-slate-50"
      }`}
    >
      <div className="flex items-start gap-3">
        <div
          className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border ${
            selected
              ? "border-blue-200 bg-white text-blue-600"
              : "border-slate-200 bg-white text-slate-400"
          }`}
        >
          <LuGlobe size={14} />
        </div>

        <div className="min-w-0 flex-1">
          <div className="flex items-start gap-2">
            <h3
              className={`line-clamp-2 flex-1 text-[13px] font-semibold leading-5 ${
                selected
                  ? "text-blue-700"
                  : "text-slate-800 group-hover:text-blue-700"
              }`}
            >
              {result.title ||
                result.displayUrl ||
                result.url}
            </h3>

            <LuExternalLink
              size={12}
              className="mt-1 shrink-0 text-slate-300"
            />
          </div>

          <p className="mt-0.5 truncate text-[11px] font-medium text-emerald-600">
            {result.displayUrl || result.url}
          </p>

          {result.snippet && (
            <p className="mt-1 line-clamp-2 text-[12px] leading-[18px] text-slate-500">
              {result.snippet}
            </p>
          )}
        </div>
      </div>
    </button>
  );
}